import {
  signInWithEmailAndPassword,
  signOut,
  User,
} from 'firebase/auth';
import { auth } from '../config/firebase';
import { clearMfaSession } from './MfaService';

export class AuthError extends Error {
  constructor(
    message: string,
    public code?: string,
  ) {
    super(message);
    this.name = 'AuthError';
  }
}

export const isAdminClaim = async (user: User, forceRefresh = false): Promise<boolean> => {
  const token = await user.getIdTokenResult(forceRefresh);
  return token.claims.admin === true;
};

export const signInAdmin = async (email: string, password: string): Promise<User> => {
  try {
    const credential = await signInWithEmailAndPassword(auth, email, password);
    const isAdmin = await isAdminClaim(credential.user, true);

    if (!isAdmin) {
      await signOut(auth);
      throw new AuthError('Bu hesap admin yetkisine sahip değil.', 'auth/unauthorized');
    }

    return credential.user;
  } catch (error: unknown) {
    if (error instanceof AuthError) {
      throw error;
    }

    const firebaseError = error as { code?: string };
    throw new AuthError(
      mapFirebaseAuthError(firebaseError.code),
      firebaseError.code,
    );
  }
};

export const signOutAdmin = async () => {
  clearMfaSession();
  await signOut(auth);
};

const mapFirebaseAuthError = (code?: string): string => {
  switch (code) {
    case 'auth/invalid-email':
      return 'Geçersiz e-posta adresi.';
    case 'auth/user-disabled':
      return 'Bu hesap devre dışı bırakılmış.';
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return 'E-posta veya şifre hatalı.';
    case 'auth/too-many-requests':
      return 'Çok fazla deneme. Lütfen daha sonra tekrar deneyin.';
    default:
      return 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.';
  }
};
